export const tenant = {
  picker: {
    via: 'via {{name}}',
    badge: {
      inactive: 'Inactive',
      pending: 'Pending activation',
      invited: 'Invited',
      deactivated: 'Deactivated',
    },
  },
  groups: {
    multipleTenants: 'Multiple tenants',
  },
};

export type TenantResources = typeof tenant;
